import React from "react";
import { connect } from "react-redux";
import {
  Jibber,
  Flex,
  SVGButton,
} from "/app/src/component";
import RatingToggle from "./_RatingToggle";
import { ButtonBarLayout } from "/app/src/layoutComponent";
import CustomizationModel from "/app/src/model/Customization/model";


class Rating extends Jibber {
  constructor(props) {
    super(props);
    this.useState({
      ratingOn: this.props.customization["rating_on"],
    });
    this.__handleOnChangeTime = this.__handleOnChangeTime.bind(this);
  }
  componentDidUpdate(prevProps, prevState) {
    if (prevProps.customization !== this.props.customization) {
      this.setState({
        ratingOn: this.state.ratingOn,
        changed: false,
      });
    }
  }

  __handleOnChangeTime(event) {
    console.log("handleOnChangeTime");
    const targetValue = event.target.value;
    //Cant be less then 0.
    if (targetValue < 0) return;
    this.setAutoresponseConfig({ time: targetValue });
  }

  render() {
    if (!this.props.customization) return "";
    const ClientChatSettingsFormularContainerStyle = {
      dataName: "ClientSettingsFormularContainer",
      grow: true,
      width: "100%",
      column: true,
      hAlignContent: "center",
    };

    const FormularSaveButtonStyle = {
      dataName: "FormularSaveButton",
      color: "black",
      hover: "blue",
      border: true,
    };
    const FormularSaveButtonProps = {
      src: "/images/Save.svg",
      text: "Spara",
      disabled: !this.state.changed,
      onClick: () => {
        this.props.updateFormular({
          rating_on: this.state.ratingOn,
        });
      },
    };
    return (
      <Flex {...ClientChatSettingsFormularContainerStyle}>
        <ButtonBarLayout>
          <Flex my="30px" column>
            <SVGButton
              {...FormularSaveButtonStyle}
              {...FormularSaveButtonProps}
            />
            <Flex
              h="10px"
              fontSize="12px"
              fontWeight="400"
              color="darkgrey"
              mt="2px"
            >
              {this.state.changed && "*Ändringar är inte sparade"}
            </Flex>
          </Flex>
        </ButtonBarLayout>

        <Flex hAlignContent="center" w="100%" h="100%" overflowY="auto">
          <Flex w="70%" column>
            <RatingToggle
              ratingOn={this.state.ratingOn}
              setRatingOn={this.setRatingOn}
            />
          </Flex>
        </Flex>
      </Flex>
    );
  }
}

const { selector: updatesSelector, dispatcher: updatesRequest } =
  CustomizationModel.updates();

const mapDispatchToProps = (dispatch, props) => ({
  updateFormular: (updates) => dispatch(updatesRequest(updates)),

});

const mapStateToProps = (state, props) => ({
  customization: updatesSelector.customization(state),
});

export default connect(mapStateToProps, mapDispatchToProps)(Rating);



// WEBPACK FOOTER //
// ./src/layout/Dashboard/MainPanel/ClientChatSettings/Rating/index.js